(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header-usp"]) return;
  try {
    
  var uspCarousel = $('.hd-Usp_Items').flickity({
    watchCSS: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: 5000
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !window.DesignMode) return;
  try {
    
var prevControl = $('.car-Products_Control-prev');
var nextControl = $('.car-Products_Control-next');
var carousel = $('.car-Products_Slides').flickity({
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: window.productCarouselBetweenSlides
});
nextControl.on('click', function () {
    carousel.flickity('next', true)
})
prevControl.on('click', function () {
    carousel.flickity('previous', true)
})

  } catch(e) { console.error(e); }
})();

})();
